import { useEffect, useMemo, useState } from "react";
import { StudentLayout } from "@/components/Layouts";
import { EventCalendar } from "@/components/EventCalendar";
import { EventDetailModal } from "@/components/EventDetailModal";
import { UpcomingEventCard } from "@/components/UpcomingEventCard";
import { EmptyState } from "@/components/EmptyState";
import { CalendarRange } from "lucide-react";
import api from "@/lib/api";

export default function StudentEvents() {
  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  const upcoming = useMemo(() => {
    const today = new Date().toISOString().slice(0, 10);
    return events.filter((e) => e.event_date >= today).slice(0, 6);
  }, [events]);

  const handleEvent = (e) => {
    setSelected(e);
    setOpen(true);
  };

  return (
    <StudentLayout title="Event Calendar">
      <div className="mb-5">
        <h1 className="text-3xl font-heading font-bold tracking-tight">Event Calendar</h1>
        <p className="mt-2 text-muted-foreground">
          View the schedule of upcoming events, webinars, classes, and programs by Maahad Bursa.
        </p>
      </div>

      <div className="rounded-2xl border border-border bg-card/40 p-4 sm:p-6 mb-8" data-testid="calendar-container">
        <EventCalendar events={events} onEventClick={handleEvent} />
      </div>

      <div>
        <h2 className="text-xl font-heading font-semibold mb-4">Upcoming Events</h2>
        {upcoming.length === 0 ? (
          <EmptyState icon={CalendarRange} title="No events" description="No events are scheduled at this time." />
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {upcoming.map((e) => <UpcomingEventCard key={e.id} event={e} onClick={handleEvent} />)}
          </div>
        )}
      </div>

      <EventDetailModal event={selected} open={open} onOpenChange={setOpen} />
    </StudentLayout>
  );
}
